export default {
  BusinessPurchaseEntryComPage: {
    header: {
      code: '入库通知单号',
      queryCode: '入库结果单号',
      supplier: '供应商',
      supplierText: '供应商编码/供应商名称',
      type: '入库单类型',
      warehouseCode: '收货仓库',
      purchaseCode: '采购单号',
      spuCode: '商品编码',
      skuCode: 'SKU编码',
      startData: '开始日期',
      endData: '结束日期',
      reviewTime: '审核时间',
      storageTime: '入库时间',
    },
    sapBtn: '推送SAP',
    errMsg1: "只能推送入库状态为'SAP推送失败'的订单",
    pushSap: '手动推送SAP',
    addOrder: '新增入库单',
    review: '审核',
    antiAudit: '反审核',
    confirmStorage: '确认入库',
    export: '导出',
    errorText: '存在状态不正确的单据，无法执行当前操作',
    msgError: '当前状态不可编辑',
    msgError2: '当前选择的采购单状态不符合推送条件，请重新选择！',
    msgBox1: '是否',
    msgBox2: '所选单据',
    msgBox3: '是否取消所选单据',
    msgBox4: '请确认入库，确认入库不可反向操作',
    downName1: '采购入库通知单导出',
    downName2: '采购入库结果单导出',
    code: '入库单号',
    applyCode: '关联采购申请单号',
    warehouseTitle: '入库单确认入库',
    outPutPdfFn: '仓库收货单PDF',
    outPutExcel: '仓库收货单EXCEL',
    auOutPutPdfFn: '澳洲采购入库单详情PDF',
    planQty: '待入库数量',
    alreadyQty: '本次入库数量',

    table: {
      supplierName: '供应商',
      typeMeaning: '入库类型',
      purchaseCode: '采购单号',
      auditDate: '最后修改时间',
      stockinDate: '入库时间',
      warehouseName: '收货仓库',
      planQty: '单据数量',
      alreadyQty: '实际入库数量',
      waitQty: '未入库数量',
      logisticsBusinessName: '物流公司',
      logisticsNo: '物流单号',
      remark: '备注',
      lastUpdateDate: '最后修改时间',
      sourceMeaning: '来源'
    }

  },
  BusinessPurchaseEntryComView: {
    purchase: '采购入库',
    statusText: '单状态',
    operationLog: '操作日志',
    statusMeaning: '入库单状态',
    inform: '单据数量',
    alreadyQty: '已入库',
    waitQty: '未入库',
    informationText: '单基本信息',
    code: '采购入库通知单号',
    resultCode: '采购入库结果单号',
    typeMeaning: '入库类型',
    supplierName: '供应商',
    warehouseName: '收货仓库',
    purchaseCode: '采购单号',
    auditDate: '审核时间',
    stockinDate: '入库时间',
    logisticsBusinessName: '物流公司',
    logisticsNo: '物流单号',
    recipientName: '收货人',
    phone: '手机',
    address: '收货地址',
    notify: '通知',
    result: '结果',
    log: '日志',
    one: '单',

    table: {
      title: '采购入库商品信息',
      spuPic: '商品图片',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      planQty: '单据数量',
      alreadyQty: '实际入库数量',
      waitQty: '未入库数量',
      taxUnitPrice: '含税下单价',
      taxRate: '税率',
      taxPrice: '含税金额',
      supplierSpuCode: '供应商商品编码',
      supplierSkuCode: '供应商SKU编码',
      remark: '商品备注'
    }
  }
};
